import { File, ImageFile } from './File';

export enum ErrorCodes {
  invalidChannel = 'invalid-channel-identifier',
  forbidden = 'Forbidden',
}

export enum CopyCutAction {
  COPY = 'COPY',
  CUT = 'CUT',
}

export enum FeedFollowBehavior {
  MANDATORY = 'MANDATORY',
  OPTIONAL_FOLLOW = 'OPTIONAL_FOLLOW',
  OPTIONAL_UNFOLLOW = 'OPTIONAL_UNFOLLOW',
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum StoryTabType {
  storyTab1 = 'storyTab1',
  storyTab2 = 'storyTab2',
  storyTab3 = 'storyTab3',
  storyTab4 = 'storyTab4',
  storyTab5 = 'storyTab5',
  pinnedStoryTab = 'pinnedStoryTab',
  pinnedStoryTab2 = 'pinnedStoryTab2',
  pinnedStoryTab3 = 'pinnedStoryTab3',
  pinnedStoryTab4 = 'pinnedStoryTab4',
  pinnedStoryTab5 = 'pinnedStoryTab5',
}

export enum UserRole {
  'admin' = 'admin',
  'editor' = 'editor',
  'editor-limited' = 'editor-limited',
  'reader' = 'reader',
  'owner' = 'owner',
  'team-member' = 'team-member',
}

export interface GalleryItem {
  title?: string;
  image?: ImageFile;
  audio?: File;
  video?: File;
  pdf?: File;
}

export interface PaginationInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  page: number;
  perPage: number;
  totalItems: number;
  totalPages: number;
}

export interface RequestError {
  data: { message: string; code: string };
}
